/**
 * @file Generated by js-routes 2.3.7. Based on Rails 7.2.3 routes of MypowergridPlatform::Application.
 * @version 3d81877187c593e7487dae7300d304675246f9d8c7fd777527172d8f7574006a
 * @see https://github.com/railsware/js-routes
 */
"use strict";
const __jsr = (() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    // Some javascript processors (like vite/rolldown)
                    // warn on using module dot exports in an ESM module.
                    // This just obfuscates that assignment a little so
                    // users don't get a warning they can't fix.
                    const _mod = module;
                    _mod.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using RubyVariables . WRAPPER
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    true
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false && result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r: utils.route.bind(utils),
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: utils.configure.bind(utils),
        config: utils.config.bind(utils),
        serialize: utils.serialize.bind(utils),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:id/accessors(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accessorsApiV1EnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accessors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/groups/:id/accessors(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accessorsApiV1GroupPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accessors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/relationships/roles(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addRolesApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:id/relationships/groups(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addToGroupsApiV1EnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/relationships/groups(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addToGroupsApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer/energy_management_systems/:id/administration/notifications(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const administrationNotificationsCustomerEnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/amperixes/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AmperixPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"amperixes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/amperix_commission_infos/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AmperixCommissionInfoPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"amperix_commission_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/amperixes(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AmperixesPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"amperixes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/certified_partner_identifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CertifiedPartnerIdentificationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"certified_partner_identifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/certified_partner_identifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CertifiedPartnerIdentificationsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"certified_partner_identifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/communities(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CommunitiesPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"communities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/communities/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CommunityPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/devices/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DevicePath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/devices(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DevicesPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/downloads/measurements(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DownloadsMeasurementsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"downloads"],[2,[7,"/"],[2,[6,"measurements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/ems_current_statuses/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EmsCurrentStatusPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"ems_current_statuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/ems_current_statuses(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EmsCurrentStatusesPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"ems_current_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/custom_events/:id(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemCustomEventPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"custom_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/custom_events(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemCustomEventsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"custom_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/ems_chai_scripts/:id(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemEmsChaiScriptPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"ems_chai_scripts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/ems_chai_scripts(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemEmsChaiScriptsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"ems_chai_scripts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/ems_meta_infos/:id(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemEmsMetaInfoPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"ems_meta_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/ems_meta_infos(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemEmsMetaInfosPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"ems_meta_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/ems_variable_stores(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemEmsVariableStoresPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"ems_variable_stores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/meter_exchange_protocols(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemMeterExchangeProtocolsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"meter_exchange_protocols"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/permission_targets(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemPermissionTargetsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"permission_targets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/target_access_permissions(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemTargetAccessPermissionsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"target_access_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EnergyManagementSystemsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/groups/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1GroupPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/groups(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1GroupsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/log_events(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1LogEventsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"log_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/map_services/geocode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1MapServicesGeocodePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"map_services"],[2,[7,"/"],[2,[6,"geocode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/map_services/timezone(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1MapServicesTimezonePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"map_services"],[2,[7,"/"],[2,[6,"timezone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/remote/claim(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1RemoteClaimPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"remote"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/remote/unlink(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1RemoteUnlinkPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"remote"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/reporters/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ReporterPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/reporters(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ReportersPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"reporters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/sensors/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SensorPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"sensors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/sensors(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SensorsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"sensors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/status_sensors/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1StatusSensorPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"status_sensors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/status_sensors(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1StatusSensorsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"status_sensors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/survey/nps/reject(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SurveyNpsRejectPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[6,"nps"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/survey/nps/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SurveyNpsSubmitPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"survey"],[2,[7,"/"],[2,[6,"nps"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/translations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1TranslationsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/translations/public(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1TranslationsPublicPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"translations"],[2,[7,"/"],[2,[6,"public"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/ui_board_configs/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UiBoardConfigPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"ui_board_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/ui_board_configs(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UiBoardConfigsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"ui_board_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UsersPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/me/relationships/certified_partner_identification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UsersMeRelationshipCertifiedPartnerIdentificationPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"certified_partner_identification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/energy_managers/:serialno/auth_remote_access(.:format)
 * @param {any} serialno
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authRemoteAccessApiV1EnergyManagerPath = /*#__PURE__*/ __jsr.r({"serialno":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"energy_managers"],[2,[7,"/"],[2,[3,"serialno"],[2,[7,"/"],[2,[6,"auth_remote_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/meter_exchange_protocols/auto_search(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autoSearchApiV1EnergyManagementSystemMeterExchangeProtocolsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"meter_exchange_protocols"],[2,[7,"/"],[2,[6,"auto_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/amperix_commission_infos/by_ems(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const byEmsApiV1AmperixCommissionInfosPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"amperix_commission_infos"],[2,[7,"/"],[2,[6,"by_ems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/amperix_commission_infos/by_serialno(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bySerialnoApiV1AmperixCommissionInfosPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"amperix_commission_infos"],[2,[7,"/"],[2,[6,"by_serialno"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/certified_partner_group_matches(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certifiedPartnerGroupMatchesApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"certified_partner_group_matches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/certified_partner_verification_confirmation(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certifiedPartnerVerificationConfirmationApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"certified_partner_verification_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/groups/:id/claim/ems(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimEmsApiV1GroupPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[2,[7,"/"],[2,[6,"ems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/groups/:id/claim/user(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimUserApiV1GroupPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[2,[7,"/"],[2,[6,"user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/sensors/measurements/energy(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const energyMeasurementsApiV1SensorsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"sensors"],[2,[7,"/"],[2,[6,"measurements"],[2,[7,"/"],[2,[6,"energy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/energy_managers/:serialno/exist(.:format)
 * @param {any} serialno
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const existApiV1EnergyManagerPath = /*#__PURE__*/ __jsr.r({"serialno":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"energy_managers"],[2,[7,"/"],[2,[3,"serialno"],[2,[7,"/"],[2,[6,"exist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/groups/:id/hierarchy(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hierarchyApiV1GroupPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hierarchy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/energy_managers/linkage_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkageStatusApiV1EnergyManagersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"energy_managers"],[2,[7,"/"],[2,[6,"linkage_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/permissions/emss(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listPermissionEmssApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[6,"emss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/sensors/measurements/mounthly_counter(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monthlyCounterMeasurementsApiV1SensorsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"sensors"],[2,[7,"/"],[2,[6,"measurements"],[2,[7,"/"],[2,[6,"mounthly_counter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/sensors/:id/measurements/nearest_counter(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nearestCounterMeasurementsApiV1SensorPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"sensors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"measurements"],[2,[7,"/"],[2,[6,"nearest_counter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /technician/energy_management_systems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTechnicianEnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"technician"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /technician/administration/energy_management_systems/:id/notifications(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationsTechnicianAdministrationEnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"technician"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:id/possessors(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const possessorsApiV1EnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"possessors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/target_access_permissions/purge(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purgeApiV1EnergyManagementSystemTargetAccessPermissionsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"target_access_permissions"],[2,[7,"/"],[2,[6,"purge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/status_sensors/measurements/raw(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rawMeasurementsApiV1StatusSensorsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"status_sensors"],[2,[7,"/"],[2,[6,"measurements"],[2,[7,"/"],[2,[6,"raw"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/groups/:id/relationships/emss(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relationshipEmssApiV1GroupPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"emss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/relationships/emss(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relationshipEmssApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"emss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:id/relationships/groups(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relationshipGroupsApiV1EnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/relationships/groups(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relationshipGroupsApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/energy_managers/:serialno/remote_access(.:format)
 * @param {any} serialno
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remoteAccessApiV1EnergyManagerPath = /*#__PURE__*/ __jsr.r({"serialno":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"energy_managers"],[2,[7,"/"],[2,[3,"serialno"],[2,[7,"/"],[2,[6,"remote_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/amperixes/:id/remote_maintenance_access(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remoteMaintenanceAccessApiV1AmperixPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"amperixes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remote_maintenance_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:id/relationships/groups(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeFromGroupsApiV1EnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/relationships/groups(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeFromGroupsApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/relationships/roles(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeRolesApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/sensors/:id/measurements/seq/:type(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seqMeasurementsApiV1SensorPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"type":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"sensors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"measurements"],[2,[7,"/"],[2,[6,"seq"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/sensors/measurements/seqs/:type(.:format)
 * @param {any} scope
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seqsMeasurementsApiV1SensorsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"type":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"sensors"],[2,[7,"/"],[2,[6,"measurements"],[2,[7,"/"],[2,[6,"seqs"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/certified_partner_identifications/:id/show(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showApiV1CertifiedPartnerIdentificationPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"certified_partner_identifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/ems_variable_stores/show(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showApiV1EnergyManagementSystemEmsVariableStoresPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"ems_variable_stores"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/permissions(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showPermissionApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/permissions/emss/:ems_id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {any} emsId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showPermissionEmsApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"ems_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[6,"emss"],[2,[7,"/"],[2,[3,"ems_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/permissions/groups/:group_id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showPermissionGroupApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"group_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/relationships/roles(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showRolesApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/ems_actuator_groups/:id/status/:oneof_type(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {any} id
 * @param {any} oneofType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusApiV1EnergyManagementSystemEmsActuatorGroupPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"id":{"r":true},"oneof_type":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"ems_actuator_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[3,"oneof_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/reporters/:id/subscribe(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribeApiV1ReporterPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/reporters/subscribed(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribedApiV1ReportersPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[6,"subscribed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/reporters/:id/subscription(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriptionApiV1ReporterPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/reporters/target_groups/:group_id(.:format)
 * @param {any} scope
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const targetGroupApiV1ReportersPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"group_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[6,"target_groups"],[2,[7,"/"],[2,[3,"group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/reporters/target_groups/relationships/emss(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const targetGroupsRelationshipEmssApiV1ReportersPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[6,"target_groups"],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[6,"emss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /technician/administration/energy_management_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianAdministrationEnergyManagementSystemsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"technician"],[2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"energy_management_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /technician/energy_management_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianEnergyManagementSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"technician"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/reporters/:id/unsubscribe(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribeApiV1ReporterPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/reporters/unsubscribed(.:format)
 * @param {any} scope
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribedApiV1ReportersPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[6,"unsubscribed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/ems_variable_stores/update(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateApiV1EnergyManagementSystemEmsVariableStoresPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"ems_variable_stores"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/users/:id/permissions/groups/:group_id(.:format)
 * @param {any} scope
 * @param {any} id
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePermissionGroupApiV1UserPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"id":{"r":true},"group_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:scope/energy_management_systems/:energy_management_system_id/meter_exchange_protocols(.:format)
 * @param {any} scope
 * @param {any} energyManagementSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const writeApiV1EnergyManagementSystemMeterExchangeProtocolsPath = /*#__PURE__*/ __jsr.r({"scope":{"r":true},"energy_management_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"scope"],[2,[7,"/"],[2,[6,"energy_management_systems"],[2,[7,"/"],[2,[3,"energy_management_system_id"],[2,[7,"/"],[2,[6,"meter_exchange_protocols"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

